var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomOnTarget = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.275 15.013 1.916-2.555a.692.692 0 0 0-.558-1.108h-3.712c-.22 0-.426.1-.558.275l-2.222 2.968a.686.686 0 0 0 0 .833l2.229 2.967a.694.694 0 0 0 .557.276h3.713a.692.692 0 0 0 .557-1.108l-1.922-2.548z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.413 16.728a5.88 5.88 0 0 1-5.6 4.103 5.878 5.878 0 0 1-5.872-5.872 5.878 5.878 0 0 1 5.872-5.872 5.88 5.88 0 0 1 5.6 4.103l1.475-1.962c.105-.145.233-.267.372-.372a8.501 8.501 0 1 0 0 8.206 1.815 1.815 0 0 1-.372-.371l-1.475-1.963z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13 14h8v2h-8a1 1 0 0 1 0-2z",
    fill: "#1B7690"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomOnTarget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-on-target.5f5a18debcf3bd0879bc9b4f99f80cf7.svg";